import {Box} from '@dropbox/dig-foundations';
import type {DcdOwnershipServiceSummary} from 'client';
import {Layout} from 'components/DSYS/Layout';
import {getTeamsAppsRoute} from 'constant';
import {useEffect, useRef} from 'react';
import {useNavigate} from 'react-router';

export const DcdOwnershipServiceList = ({
  activeServiceId,
  onNavigate,
  onSelect,
  services,
  bleed,
}: {
  activeServiceId?: number;
  onNavigate?: () => void;
  onSelect?: (rank: number) => void;
  services: DcdOwnershipServiceSummary[];
  // Full-bleed rows in the page rail; rounded rows in the narrow screens' nav.
  bleed?: {left: number; right: number};
}) => {
  const navigate = useNavigate();
  const selectedRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    selectedRef.current?.scrollIntoView({block: 'center', inline: 'nearest'});
  }, [activeServiceId]);

  return (
    <Box style={bleed ? {marginLeft: -bleed.left, marginRight: -bleed.right} : undefined}>
      {services.map((service, rank) => {
        const isSelected = service.id === activeServiceId;
        const href = getTeamsAppsRoute(service.id);
        return (
          <div key={service.id} ref={isSelected ? selectedRef : undefined}>
            <Layout.RailTreeRow
              label={service.name}
              selected={isSelected}
              href={href}
              onActivate={() => {
                onSelect?.(rank);
                onNavigate?.();
                navigate(href);
              }}
              bleed={bleed}
            />
          </div>
        );
      })}
    </Box>
  );
};
